import { render, staticRenderFns } from "./limitCoins.vue?vue&type=template&id=f4ec317c&scoped=true&"
import script from "./limitCoins.vue?vue&type=script&lang=ts&"
export * from "./limitCoins.vue?vue&type=script&lang=ts&"
import style0 from "./limitCoins.scss?vue&type=style&index=0&id=f4ec317c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ec317c",
  null
  
)

export default component.exports